(function () {
  function packPlan(cart, counts, iceVariantId, selected) {
    let required = 0;
    const iceLines = [];
    for (const item of cart.items) {
      if (String(item.variant_id) === String(iceVariantId)) {
        iceLines.push(item);
        continue;
      }
      if (!Object.prototype.hasOwnProperty.call(counts, item.variant_id)) {
        throw new Error('Cart changed. Refresh your bag.');
      }
      required += item.quantity * counts[item.variant_id];
    }
    const quantity = selected ? required : 0;
    const updates = {};
    const reusable = iceLines.find(item => !item.selling_plan_allocation);
    for (const item of iceLines) {
      const target = item === reusable ? quantity : 0;
      if (item.quantity !== target) updates[item.key] = target;
    }
    return { required, updates, add: !reusable ? quantity : 0 };
  }

  async function syncPacks(cart, counts, iceVariantId, selected, request) {
    const plan = packPlan(cart, counts, iceVariantId, selected);
    let changed = false;
    if (Object.keys(plan.updates).length) {
      cart = await request('update', { updates: plan.updates });
      changed = true;
    }
    if (plan.add) {
      await request('add', { items: [{ id: iceVariantId, quantity: plan.add }] });
      changed = true;
    }
    return changed;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { packPlan, syncPacks };
    return;
  }

  function initialize() {
    const root = document.querySelector('[data-elaa-ice-cart]');
    const dataElement = root && root.querySelector('[data-ice-config]');
    if (!dataElement || root.dataset.iceInitialized) return;
    const config = JSON.parse(dataElement.textContent);
    if (!config.enabled || !config.variantId) return;
    root.dataset.iceInitialized = 'true';
    const form = root.querySelector('.elaa-cart-form');
    const checkbox = root.querySelector('[data-ice-select]');
    const status = root.querySelector('[data-ice-status]');
    const total = root.querySelector('[data-ice-total]');
    const count = root.querySelector('[data-ice-count]');
    const packLabel = root.querySelector('[data-ice-label]');
    const panel = root.querySelector('[data-ice-panel]');
    if (!form || !checkbox) return;
    let busy = false;
    const controls = Array.from(form.querySelectorAll('button, input'));
    const rootUrl = window.Shopify.routes.root;

    function setBusy(value) {
      busy = value;
      form.setAttribute('aria-busy', String(value));
      controls.forEach(control => { control.disabled = value; });
    }

    function showError() {
      status.textContent = config.error;
      status.hidden = false;
      status.focus();
    }

    async function request(action, payload) {
      const response = await fetch(rootUrl + 'cart/' + action + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(config.error);
      return result;
    }

    async function currentCart() {
      const response = await fetch(rootUrl + 'cart.js', { cache: 'no-store' });
      if (!response.ok) throw new Error(config.error);
      return response.json();
    }

    function requiredInForm() {
      let packs = 0;
      form.querySelectorAll('[data-ice-units]').forEach(input => {
        const quantity = Math.max(0, Math.floor(Number(input.value) || 0));
        packs += quantity * Number(input.dataset.iceUnits);
      });
      return packs;
    }

    function refreshPreview() {
      const packs = requiredInForm();
      count.textContent = String(packs);
      if (packLabel && config.packLabels) {
        const category = new Intl.PluralRules(document.documentElement.lang || 'en').select(packs);
        packLabel.textContent = config.packLabels[category] || config.packLabels.other;
      }
      total.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: config.currency
      }).format(packs * config.price / 100);
      panel.hidden = packs === 0 && !checkbox.checked;
    }

    async function submitChanges(checkout) {
      if (busy || !form.reportValidity()) return;
      const selected = checkbox.checked;
      const updates = {};
      form.querySelectorAll('[data-cart-key]').forEach(input => {
        if (input.dataset.iceLine !== 'true') {
          updates[input.dataset.cartKey] = Math.max(0, Math.floor(Number(input.value) || 0));
        }
      });
      setBusy(true);
      status.hidden = true;
      try {
        const cart = await request('update', { updates });
        await syncPacks(cart, config.counts, config.variantId, selected, request);
        const verified = await currentCart();
        const pending = packPlan(verified, config.counts, config.variantId, selected);
        if (Object.keys(pending.updates).length || pending.add) throw new Error(config.error);
        if (checkout) {
          const checkoutForm = document.createElement('form');
          checkoutForm.method = 'post';
          checkoutForm.action = rootUrl + 'cart';
          const input = document.createElement('input');
          input.type = 'hidden'; input.name = 'checkout'; input.value = 'Checkout';
          checkoutForm.appendChild(input);
          document.body.appendChild(checkoutForm);
          checkoutForm.submit();
        } else {
          window.location.reload();
        }
      } catch (error) {
        setBusy(false);
        showError();
      }
    }

    form.addEventListener('submit', event => {
      event.preventDefault();
      submitChanges(event.submitter && event.submitter.name === 'checkout');
    });
    form.addEventListener('input', refreshPreview);
    checkbox.addEventListener('change', () => submitChanges(false));
    form.addEventListener('click', event => {
      const remove = event.target.closest('[data-ice-remove]');
      if (busy && event.target.closest('a')) { event.preventDefault(); return; }
      if (!remove) return;
      event.preventDefault();
      checkbox.checked = false;
      submitChanges(false);
    });
    refreshPreview();

    if (config.hasPacks) {
      setBusy(true);
      currentCart().then(cart => syncPacks(cart, config.counts, config.variantId, true, request))
        .then(changed => {
          if (changed) window.location.reload();
          else setBusy(false);
        }).catch(() => { setBusy(false); showError(); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
}());
